import React, { createContext, useContext, useMemo, } from "react";
import { FontIcon } from "./FontIcon";
var DEFAULT_ICONS = {
    back: React.createElement(FontIcon, null, "keyboard_arrow_left"),
    checkbox: React.createElement(FontIcon, null, "check_box"),
    download: React.createElement(FontIcon, null, "file_download"),
    dropdown: React.createElement(FontIcon, null, "arrow_drop_down"),
    error: React.createElement(FontIcon, null, "error_outline"),
    expander: React.createElement(FontIcon, null, "keyboard_arrow_down"),
    forward: React.createElement(FontIcon, null, "keyboard_arrow_right"),
    menu: React.createElement(FontIcon, null, "menu"),
    notification: React.createElement(FontIcon, null, "notifications"),
    password: React.createElement(FontIcon, null, "remove_red_eye"),
    radio: React.createElement(FontIcon, null, "radio_button_checked"),
    selected: React.createElement(FontIcon, null, "check"),
    sort: React.createElement(FontIcon, null, "arrow_upward"),
};
var context = createContext(DEFAULT_ICONS);
var Provider = context.Provider;
/**
 * Gets one of the configured icons from the `IconProvider`. This is probably
 * just for use within `react-md`, but might be helpful outside if you want to
 * reuse the existing icon configuration for other custom components.
 *
 * If te second argument is provided and it is not `undefined`, that value will
 * be used instead of the inherited icon type.
 *
 * @param name - The name of the icon you want to use.
 * @param override - An optional override to use instead of the inherited icon.
 * @returns The overridden icon value or the inherited icon.
 */
export function useIcon(name, override) {
    var icons = useContext(context);
    if (typeof override !== "undefined") {
        return override;
    }
    return icons[name];
}
/**
 * The `IconProvider` component is used to override all the default icons within
 * `react-md` with a newly defined set of icons. This is super nice since you
 * won't need to create new component wrappers for all the components within
 * `react-md` if you want to switch to SVG icons instead of the default font
 * icons.
 */
export function IconProvider(_a) {
    var children = _a.children, _b = _a.back, back = _b === void 0 ? DEFAULT_ICONS.back : _b, _c = _a.checkbox, checkbox = _c === void 0 ? DEFAULT_ICONS.checkbox : _c, _d = _a.download, download = _d === void 0 ? DEFAULT_ICONS.download : _d, _e = _a.dropdown, dropdown = _e === void 0 ? DEFAULT_ICONS.dropdown : _e, _f = _a.expander, expander = _f === void 0 ? DEFAULT_ICONS.expander : _f, _g = _a.error, error = _g === void 0 ? DEFAULT_ICONS.error : _g, _h = _a.forward, forward = _h === void 0 ? DEFAULT_ICONS.forward : _h, _j = _a.menu, menu = _j === void 0 ? DEFAULT_ICONS.menu : _j, _k = _a.notification, notification = _k === void 0 ? DEFAULT_ICONS.notification : _k, _l = _a.password, password = _l === void 0 ? DEFAULT_ICONS.password : _l, _m = _a.radio, radio = _m === void 0 ? DEFAULT_ICONS.radio : _m, _o = _a.selected, selected = _o === void 0 ? DEFAULT_ICONS.selected : _o, _p = _a.sort, sort = _p === void 0 ? DEFAULT_ICONS.sort : _p;
    var value = useMemo(function () { return ({
        back: back,
        checkbox: checkbox,
        download: download,
        dropdown: dropdown,
        error: error,
        expander: expander,
        forward: forward,
        menu: menu,
        notification: notification,
        password: password,
        radio: radio,
        selected: selected,
        sort: sort,
    }); }, [
        back,
        checkbox,
        download,
        dropdown,
        error,
        expander,
        forward,
        menu,
        notification,
        password,
        radio,
        selected,
        sort,
    ]);
    return React.createElement(Provider, { value: value }, children);
}
/* istanbul ignore next */
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        IconProvider.propTypes = {
            children: PropTypes.node,
            back: PropTypes.node,
            checkbox: PropTypes.node,
            download: PropTypes.node,
            dropdown: PropTypes.node,
            error: PropTypes.node,
            expander: PropTypes.node,
            forward: PropTypes.node,
            menu: PropTypes.node,
            notification: PropTypes.node,
            password: PropTypes.node,
            radio: PropTypes.node,
            selected: PropTypes.node,
            sort: PropTypes.node,
        };
    }
    catch (e) { }
}
//# sourceMappingURL=IconProvider.js.map